import Vue from "vue"
import Vuex from "vuex"

import { state } from "./state"
import { mutations } from "./mutations"

Vue.use(Vuex)

export default new Vuex.Store({
    state: state,
    mutations: mutations
})


// WEBPACK FOOTER //
// ./src/pages/act/202010/unit_member/store/store.js